import Cookies from 'js-cookie';
import type { ChatbotEnv, ChatbotInitConfig } from './types';

const LOCALE_MAP: Record<string, string> = {
  en: 'en',
  'zh-tw': 'zh-tw',
  'uk-ua': 'uk-ua',
  es: 'es',
  ru: 'ru',
  vi: 'vi',
  de: 'de',
  tr: 'tr',
  fr: 'fr',
  pt: 'pt',
  ko: 'ko-kr',
  ar: 'ar',
};

export function getChatbotLocale(nextLocale: string): string {
  return LOCALE_MAP[nextLocale] ?? 'en';
}

export function getChatbotCdnBase(navUrl: string, fallback: string): string {
  try {
    const url = new URL(navUrl);
    return url.origin;
  } catch {
    return fallback;
  }
}

export function getChatbotSdkUrl(navUrl: string, fallback: string): string {
  return `${getChatbotCdnBase(navUrl, fallback)}/sdk/chat-bot/chatbot-entry.js`;
}

export function getChatbotWsDomain(baseUrl: string, wsBaseDomain: string): string {
  try {
    const host = new URL(baseUrl).hostname;
    const match = host.match(/^((?:dev|test|pre|prod)(?:-unique|-mirror)?)-/);
    const prefix = match ? `${match[1]}-` : '';
    return `${prefix}${wsBaseDomain}`;
  } catch {
    return wsBaseDomain;
  }
}

export function getChatbotConfig(
  env: ChatbotEnv,
  options: {
    locale: string;
    theme: 'dark' | 'light';
    pageType?: 'trade' | 'default';
    token?: string;
    uid?: string;
  }
): ChatbotInitConfig {
  return {
    lang: getChatbotLocale(options.locale),
    theme: options.theme,
    pageType: options.pageType ?? 'default',
    token: options.token ?? '',
    uid: options.uid,
    geetestCaptchaId: env.geetestCaptchaId ?? '',
    apiBaseUrl: env.baseUrl,
    wsBaseUrl: getChatbotWsDomain(env.baseUrl, env.wsBaseDomain),
    helpCenterBaseUrl: env.helpCenterUrl,
    cfIpCountry: Cookies.get('cf-ipcountry') ?? '',
  };
}
